import wixLocation from 'wix-location'

import { sendBi } from 'public/biModule'
import { session } from 'wix-storage'

$w.onReady(function () {
    const pageName = getPageName()

    savePreviousPageName(pageName)
    wixLocation.onChange(() => {
        savePreviousPageName(pageName)
    })

    $w('#goToWixButton').onClick(() => {
        sendBi('goToWix', {
            'name': pageName
        })
    })
})

const savePreviousPageName = (pageName) => {
    const wasRefreshed = pageName === session.getItem('currentPageName')
    if (!wasRefreshed) {
        session.setItem('previousPageName', session.getItem('currentPageName'))
        session.setItem('currentPageName', pageName)
    }
}

const getPageName = () => {
    if (wixLocation.prefix) {
        return `${wixLocation.prefix}/${wixLocation.path.join('/')}`
    } else if (wixLocation.path.length > 0) {
        return wixLocation.path.join('/')
    } else {
        return 'home'
    }
}